import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { registerUser } from './features/mfaSlice';
import { toast } from 'react-toastify';
import {
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  Grow,
} from "@mui/material";
import images from "../src/assests/images/bk_img1.jpg";
import logo from "../src/assests/images/logo1.png";
import Loginservice from "./helper/Api";

const EnableMFA = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.mfa);

  const [showCard, setShowCard] = useState(false);

  const handleRegister = async () => {
    // Validation
    if (!email.trim() && !password.trim()) {
      toast.error("Please enter the email and password");
      return;
    }
    if (!email.trim()) {
      toast.error("Please enter the email");
      return;
    }
    if (!password.trim()) {
      toast.error("Please enter the password");
      return;
    }

    const payload = {
      email: email.trim(),
      password: password.trim(),
    };

    try {
      const resultAction = await dispatch(registerUser(payload));
      if (registerUser.fulfilled.match(resultAction)) {
        localStorage.setItem("userData", JSON.stringify({ email: email.trim() }));
        navigate("/welcome");
      }
    } catch (error) {
      console.error("Registration error:", error);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleRegister();
    }
  };

  useEffect(() => {
    setShowCard(true);
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        height: "100vh",
        width: "100%",
        overflow: "hidden",
        // Background image styling
        backgroundImage: `url(${images})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Semi-transparent overlay to improve text readability */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.4)", // Dark overlay for better contrast
          zIndex: 0,
        }}
      />

      {/* Centered card with animation */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
        px={2}
        position="relative" // Ensure it's above the overlay
        zIndex={1}
      >
        <Grow in={showCard} timeout={1000}>
          <Card
            sx={(theme) => ({
              width: {
                xs: "90%",
                sm: "65%",
                md: "45%",
                lg: "35%",
                xl: "28%",
              },
              maxWidth: 450,
              padding: 2,
              backgroundColor: "rgba(255, 255, 255, 0.95)", // Slightly transparent white
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: 3,
              borderRadius: 2,
              backdropFilter: "blur(5px)", // Frosted glass effect
            })}
          >
            <CardContent
              sx={{ width: "100%", p: 1, "&:last-child": { pb: 1 } }}
            >
              {/* Logo with description below */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  mb: 1.5,
                }}
              >
                <img
                  src={logo}
                  alt="Lucas TVs Logo"
                  style={{ width: "100%", maxWidth: "150px", height: "auto" }}
                />
                <Typography
                  variant="subtitle1"
                  align="center"
                  color="text.primary"
                  fontSize="16px"
                  fontWeight="Bold"
                  sx={{ marginTop: 0.5 }}
                >
                  MFA
                </Typography>
              </Box>

              {/* Email */}
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                margin="dense"
                size="small"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyPress={handleKeyPress}
                disabled={loading}
                sx={{ mb: 1 }}
              />

              {/* Password */}
              <TextField
                label="Password"
                type="password"
                variant="outlined"
                fullWidth
                margin="dense"
                size="small"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
                disabled={loading}
                sx={{ mb: 1 }}
              />

              <Button
                variant="contained"
                size="small"
                fullWidth
                sx={{
                  paddingX: 3,
                  fontSize: "0.9rem",
                  backgroundImage: "linear-gradient(45deg, #7DF9FF, #00BFFF)",
                  "&:hover": {
                    backgroundImage: "linear-gradient(45deg, #00BFFF, #7DF9FF)",
                  },
                  height: "40px",
                  marginTop: "8px",
                }}
                onClick={handleRegister}
                disabled={loading}
              >
                {loading ? "..." : "Register"}
              </Button>

              {/* Enable MFA Link - Properly aligned to the right */}
              {/* <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  mt: 1,
                  gap: "4px",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "0.875rem",
                    color: "#000",
                    whiteSpace: "nowrap",
                  }}
                >
                  Already have account?
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    color: "#00BFFF",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    textDecoration: "underline",
                    textUnderlineOffset: "3px",
                    textDecorationColor: "rgba(0, 191, 255, 0.3)",
                    "&:hover": {
                      color: "#7DF9FF",
                      textDecorationColor: "#7DF9FF",
                    },
                    transition: "all 0.2s ease",
                    fontSize: "0.875rem",
                    fontWeight: 500,
                  }}
                  onClick={() => navigate("/")}
                >
                  Login
                </Typography>
              </Box> */}

              {/* Error message */}
              {error && (
                <Alert
                  severity="error"
                  sx={{ marginTop: 1.5, fontSize: "0.8rem", py: 0.5 }}
                >
                  {error}
                </Alert>
              )}
            </CardContent>
          </Card>
        </Grow>
      </Box>
    </Box>
  );
};

export default EnableMFA;
